import { useEffect, useState } from "react";
import PageHeader from "../components/layout/PageHeader";
import api from "../lib/api";
import ClosingCountdownBanner from "../components/ClosingCountdownBanner";
import RiskAlertsBanner from "../components/RiskAlertsBanner";
import NumberRankings from "../components/NumberRankings";
import { TrendingUp, Banknote, Ticket, XCircle, Clock, Gamepad2, Store, Users as UsersIcon } from "lucide-react";

function StatCard({ icon: Icon, label, value, prefix = "", testId, accent = "text-slate-950" }) {
  return (
    <div className="bg-white border border-slate-200 rounded-sm p-4 flex flex-col gap-2" data-testid={testId}>
      <div className="flex items-center justify-between">
        <div className="text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500">{label}</div>
        <Icon className="w-4 h-4 text-slate-400" />
      </div>
      <div className={`text-3xl font-black font-mono ${accent}`}>
        {prefix}
        {value}
      </div>
    </div>
  );
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/dashboard/stats").then(({ data }) => {
      setStats(data);
      setLoading(false);
    });
  }, []);

  const fmt = (n) => (n || 0).toLocaleString("es-DO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const fmtInt = (n) => (n || 0).toLocaleString("es-DO");

  return (
    <div className="flex-1 bg-slate-50 min-h-full">
      <PageHeader
        title="Panel de Control"
        subtitle="Resumen operativo del día · Actualización en vivo"
        testId="dashboard-header"
      />

      <div className="p-6 sm:p-8 space-y-6">
        <RiskAlertsBanner />
        {loading ? (
          <div className="text-slate-500 text-sm">Cargando métricas…</div>
        ) : (
          <>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              <StatCard icon={TrendingUp} label="Ventas Hoy" value={fmt(stats.sales_today)} prefix="RD$ " testId="stat-sales" accent="text-blue-700" />
              <StatCard icon={Banknote} label="Premios Pagados" value={fmt(stats.payouts_today)} prefix="RD$ " testId="stat-payouts" accent="text-green-700" />
              <StatCard icon={Ticket} label="Tickets Emitidos" value={fmtInt(stats.tickets_today)} testId="stat-tickets" />
              <StatCard icon={XCircle} label="Cancelados" value={fmtInt(stats.cancelled_today)} testId="stat-cancelled" accent="text-red-700" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2 space-y-4">
                <ClosingCountdownBanner />
              </div>

              <div className="space-y-4">
                <div className="bg-white border border-slate-200 rounded-sm p-5">
                  <div className="text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500 mb-3">
                    Estado del sistema
                  </div>
                  <div className="space-y-3">
                    <Row icon={Gamepad2} label="Juegos activos" value={stats.active_games} />
                    <Row icon={Store} label="Sucursales" value={stats.total_branches} />
                    <Row icon={UsersIcon} label="Usuarios" value={stats.total_users} />
                  </div>
                </div>
              </div>
            </div>

            <NumberRankings />
          </>
        )}
      </div>
    </div>
  );
}

function Row({ icon: Icon, label, value }) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2 text-sm text-slate-700">
        <Icon className="w-4 h-4 text-slate-400" />
        <span>{label}</span>
      </div>
      <div className="font-mono font-bold text-slate-950">{value}</div>
    </div>
  );
}
